// 销售计划完成率报表-->中英文
export const salesPlanLocale = {
    'zhCN': {
        achievingRateReport: {
            planQuantityBatch: '计划数量(1批次)',
            planQuantityCount: '计划总数量',
            completedQuantity: '已完成数量',
            residueQuantity: '剩余数量',
            kpiQuantity: '计划KPI数量',
            completeRate: '完成率',
            inCompletedSalesPlanNotification: '发送未完成计划提醒',
            sendSuccssfully:'未完成计划提醒发送成功',
            achievingRateReportSumPlanQuantity:'计划总数量合计',
            achievingRateReportSumSalesQuantity:'已完成数量合计',
            achievingRateReportSumSurplusQuantity:'剩余数量合计',
            achievingRateReportSumPlanPrice:'计划总金额合计',
            achievingRateReportSumCompleteSalesPrice:'已完成金额合计',
            achievingRateReportSumSurplusPrice:'剩余金额合计',
            planPrice:'计划总金额',
            completeSalesPrice:'已完成金额',
            surplusPrice:'剩余金额'
        },
        salesPlan: {
            remainPlanQuantity: '剩余计划数量',
            effectiveQuantity: '已生效计划数量',
            totalSalesPlanQuantity: '总计划数',
            supplementarySalePlan: '补充销售计划',
            SentMonthSalesPlanToSno: '推送计划至SODA',
            receiverEmployeeMUID: '负责人MUID',
            receiverEmployeeName: '负责人',
            planMonth: '计划月份',
            batch: '批次',
            provinceName: '省份',
            cityName: '城市',
            receiverName: '流向商业名称',
            receiverPHCode: 'PHCode',
            productMaterialGroup: '产品/分型',
            materialGroup: '分型',
            productReferred: '产品简称',
            planQuantity: '原始计划数量',
            requiredQuantity: '需求数量',
            finalQuantity: '最终数量',
            finalPrice: '最终金额',
            planStatus: '状态',
            planImportMonth: '月份',
            planMonthEmpty: '请选择月份',
            isPricePriceAgreementTermination: '价格协议是否已终止',
            kpi: 'KPI',
            remark: '备注',
            newRemark: '追加备注',
            addPlanQuantity: '计划数量',
            kpiTotal: 'KPI合计',
            quantityTotal: '计划总量',
            allowedAdd: '是否允许追加',
            addSwitch: '追加开关',
            salesPlanManagement: '编辑销售计划',
            salesPlanAdjustmentManagement: '调整销售计划',
            confirmEditSalesPlan: '确定修改销售计划数量？',
            confirmAdjustmentSalesPlan: '确定调整销售计划数量？',
            confirmSettingKPI: '是否确定设置KPI？',
            salesPlanMaxNumberLength: '请输入整数，最大支持9位整数',

            statusWaitingForConfirm: '待确认',
            statusUpdated: '已确认',
            statusConfirm: '已生效',
            statusToBeEffective: '草稿',
            statusRejected: '已拒绝',
            statusWaitingApproval: '待审批',

            batchDelete: '批量删除',
            batchRelease: '通知确认',
            allRelease: '全部通知确认',
            batchMandatoryConfirmation: '批量强制确认',
            confirmPlan: '确认',
            mandatoryConfirmation: '强制确认',
            adjustmentPlan: '调整',
            kpiSetting: 'KPI设置',

            confirmDeleteSalesPlan: '确定删除销售计划？',
            deleteBatchSalesPlan: '确定批量删除销售计划？',
            releaseBatchSalesPlan: '确定批量通知销售计划？',
            confirmSalesPlan: '确定确认销售计划？',
            confirmBatchSalesPlan: '确定批量确认销售计划？',
            confirmMandatorySalesPlan: '确定强制确认销售计划？',
            confirmBatchMandatorySalesPlan: '确定强制确认状态为“草稿”、“待确认”、“待审批”和“已确认”状态的销售计划？',
            pleaseSelectUpdateStatusData: '只能确认状态为“已确认”、“待审批”的数据',
            pleaseSelectToBeEffectiveStatusData: '只能通知状态为“草稿”数据',
            confirmNoticeAllWaitReleaseStatusData: '全部确认并通知“草稿”数据？',
            downloadImportTemplate: '下载导入模板',
            pleaseSelectCanConfirmStatusData: '只能确认状态为“草稿”、“待确认”和“有更新”数据',
            SentMonthSalesPlanToSnoMessage: '该操作将同步当前所选月份中未推送或推送失败的销售计划到SODA系统，确认推送？',

            addSalesPlan: '新增销售计划',
            chooseMaterialGroup: '请选择分型',
            materialGroupRepeat: '已存在相同分型，请勿重复添加',
            settingResponsibilityer: '请维护该商业公司负责人后，重新选择',
            updateKPI: '更新KPI',
            selectSalesPlan: '选择销售计划',
            notSelectSalesPlans: '请选择销售计划',
            confirmUpdateKPI: '是否确定更新KPI？',
            close: '关闭补充',
            start: '开启补充',
            feadBackUserName: '反馈人',
            feadBackTime: '反馈时间',
            salesPlanMaxRemarkLength: '备注超过可输入的最大长度',
            total: '最终数量合计',
            totalPrice: '最终金额合计',
            selectCustomer: '客户选择',
            capacity: '件容量',
            chooseDistributor: '请选择客户',
            quantityNull: '请输入需求数量',
            supplementaryRoleWarning: '该功能只对外勤开放',
            addRoleWarning: '该功能只对内勤开放',
            coefficient: '销量系数',
            salesCoefficient: '销量系数维护',
            editSalesCoefficientSuccessfully: '编辑销量系数成功',
            salesCoefficienBeEmpty: '销量系数不能为空',
            coefficientValidate: '销量系数最多九位整数，四位小数',
            totalPlanQuantity: '计划数量',
            
            yearMonthBeEmpty: '年月不能为空',
            yearMonth: '年月',
            planQuantitySum: '计划数量合计',
            updateTip1: '（按年月&PHCode&分型精准覆盖）',
            updateTip2: '（按年月全量覆盖）',
            shipper: '货主',
        },
        salesPlanDistributionReport:{
            calculate: '计算',
            calculateSuccessfully: '计算成功',

            lastTwoMonthEstimateInventory: '月库存预估',
            lastThreeMonthSalesAvg: '前3月平均出货量',
            lastMonthEffectivePlan: '月生效计划',
            lastMonthEstimateInventoryAvg: '月库存预估数量-按工作日',
            lastMonthEstimateInventoryDayAvg: '月库存预估天数-按工作日',
            distributionRatio: '分货比例',
            expectedInventoryDays: '期望库存天数',
            thisMonthReplenishment: '月追加EFS',
            thisMonthEstimateInventoryDay: '月追加EFS后预估库存天数-按月均',
            additionalPlan: '追加计划',
            ifAdditionalPlan: '是否有追加计划'
        }
    },
    'enUS': {
        achievingRateReport: {
            planQuantityBatch: 'Planned quantity (1 batch)',
            planQuantityCount: 'Total number of plans',
            completedQuantity: 'Number completed',
            residueQuantity: 'The remaining amount',
            kpiQuantity: 'KPI Quantity',
            completeRate: 'The completion rate',
            inCompletedSalesPlanNotification: 'Send imcompleted sales plan notification',
            sendSuccssfully:'Send imcompleted sales plan notification successfully',
            achievingRateReportSumPlanQuantity:'SumPlanQuantity',
            achievingRateReportSumSalesQuantity:'SumSalesQuantity',
            achievingRateReportSumSurplusQuantity:'SumSurplusQuantity',
            achievingRateReportSumPlanPrice:'SumPlanPrice',
            achievingRateReportSumCompleteSalesPrice:'SumCompleteSalesPrice',
            achievingRateReportSumSurplusPrice:'SumSurplusPrice',
            planPrice:'planPrice',
            completeSalesPrice:'completeSalesPrice',
            surplusPrice:'surplusPrice'
        },
        salesPlan: {
            remainPlanQuantity: 'Remain Plan Quantity',
            effectiveQuantity: 'Effective Quantity',
            totalSalesPlanQuantity: 'Total Quantity',
            supplementarySalePlan: 'Supplementary SalePlan',
            SentMonthSalesPlanToSno: 'Push plan to SODA',
            receiverEmployeeMUID: 'Person in charge MUID',
            receiverEmployeeName: 'principal',
            planMonth: 'Planned month',
            batch: 'Batch',
            provinceName: 'Province',
            cityName: 'City',
            receiverName: 'Flow to business name',
            receiverPHCode: 'PHCode ',
            productMaterialGroup: 'Product / Classification',
            materialGroup: 'Material Group',
            productReferred: 'Product short name',
            planQuantity: 'Planned quantity',
            requiredQuantity: 'Required quantity',
            finalQuantity: 'Final Quantity',
            planStatus: 'status',
            planImportMonth: 'Month',
            planMonthEmpty: 'Please select month',
            isPricePriceAgreementTermination: 'PriceAgreementTerminated',
            kpi: 'KPI',
            kpiTotal: 'Total KPI',
            quantityTotal: 'Total quantity',
            allowedAdd: 'Allowed Add',
            addSwitch: 'Add Switch',
            remark: 'Remark',
            newRemark: 'New Remark',
            kpiSetting: 'KPI Setting',
            addPlanQuantity: 'Plan Quantity',
            salesPlanManagement: 'Edit sales plan',
            salesPlanAdjustmentManagement: 'Adjustment Sales Plan',
            confirmEditSalesPlan: 'Are you sure to change the number of sales plans?',
            confirmAdjustmentSalesPlan: 'Determine the number of revisions to the sales plan？',
            confirmSettingKPI: 'Are you sure to set KPI ？',
            salesPlanMaxNumberLength: 'Enter integers to support up to 9-bit integers',
            confirmDeleteSalesPlan: 'Are you sure to delete the sales plan?',
            deleteBatchSalesPlan: 'Are you sure to delete the sales plan in bulk?',
            releaseBatchSalesPlan: 'Determine the volume notification sales plan?',
            confirmSalesPlan: 'Are you sure to confirm your sales plan?',
            confirmBatchSalesPlan: 'Are you sure to confirm the sales plan in bulk?',
            confirmMandatorySalesPlan: 'Determine the mandatory confirmation of the sales plan?',
            confirmBatchMandatorySalesPlan: 'Do you want to confirm the sales plan with the status of draft, to be confirmed, to be approved and confirmed?',
            statusWaitingForConfirm: 'WaitingForConfirm',
            statusUpdated: 'Updated',
            statusConfirm: 'Confirm',
            statusToBeEffective: 'ToBeEffective',
            statusRejected: 'Rejected',
            statusWaitingApproval: 'WaitingApproval',
            batchDelete: 'Batch Delete',
            batchRelease: 'Batch Release',
            allRelease: 'All Notice Confirm',
            batchMandatoryConfirmation: 'All batch confirmation',
            confirmPlan: 'Confirm',
            mandatoryConfirmation: 'Mandatory confirmation',
            adjustmentPlan: 'Adjustment',
            pleaseSelectUpdateStatusData: 'Only data in the status of "confirmed" or "pending approval" can be confirmed',
            pleaseSelectToBeEffectiveStatusData: 'Can only notify data whose status is "Pending Effectiveness"',
            confirmNoticeAllWaitReleaseStatusData: 'Confirm and notify all "to be effective" data??',
            downloadImportTemplate: 'DownloadImportTemplate',
            addSalesPlan: 'Add Sales Plan',
            chooseMaterialGroup: 'Please choose material group',
            materialGroupRepeat: 'The same material group already exists. Do not add it again ',
            settingResponsibilityer: 'After maintaining the person in charge of the business company, please choose again.',
            pleaseSelectCanConfirmStatusData: 'Only confirm that the status is "to be effective", "to be confirmed", and "updated" data',
            SentMonthSalesPlanToSnoMessage: 'This operation will synchronize sales plans that have not been pushed or have failed to be pushed in the currently selected month to the SODA system. Confirm the push?',
            updateKPI: 'Update KPI',
            selectSalesPlan: 'Select SalesPlan',
            notSelectSalesPlans: 'Please select salesplans',
            confirmUpdateKPI: 'Confirm Update KPI？',
            close: 'Close supplement',
            start: 'Opening supplement',
            feadBackUserName: 'FeadBack User Name',
            feadBackTime: 'FeadBack Time',
            salesPlanMaxRemarkLength: 'Note exceeds the maximum length that can be entered ',
            total: 'Total final quantity',
            totalPrice: 'Total final price',
            selectCustomer: 'Customer Selection',
            capacity: 'Piece capacity',
            chooseDistributor: 'Please select a customer.',
            quantityNull: 'Please enter the required quantity.',
            supplementaryRoleWarning: 'This function is only available to field workers.',
            addRoleWarning: 'This function is only available to internal staff.',
            coefficient: 'SalesFactor',
            salesCoefficient: 'SalesFactor',
            editSalesCoefficientSuccessfully: 'Success',
            salesCoefficienBeEmpty: 'Sales coefficient can not be empty',
            coefficientValidate: 'Sales coefficient up to nine-digit integer, four decimal places',
            totalPlanQuantity: 'TotalEFSPlan',
            yearMonthBeEmpty: 'Year month can not be empty',
            yearMonth: 'YearMonth',
            planQuantitySum: 'SumTotalEFSPlan',
            updateTip1: '（按年月&PHCode&分型精准覆盖）',
            updateTip2: '（按年月全量覆盖）',
        },
        salesPlanDistributionReport:{
            calculate: 'Calculate',
            calculateSuccessfully: 'Success',
            
            lastTwoMonthEstimateInventory: 'FcstStock',
            lastThreeMonthSalesAvg: 'Avg3MonthStockOut',
            lastMonthEffectivePlan: 'EffectivePlan',
            lastMonthEstimateInventoryAvg: 'FcstStock_WD',
            lastMonthEstimateInventoryDayAvg: 'FcstStockDays_WD',
            distributionRatio: 'AllocationRate',
            expectedInventoryDays: 'ExpectedStockDays',
            thisMonthReplenishment: 'AddedEFS',
            thisMonthEstimateInventoryDay: 'FcstStockDays_Added_Avg',
            additionalPlan: 'AdditionalPlan',
            ifAdditionalPlan: 'IfAdditionalPlan'
        }
    }
}
export default salesPlanLocale



// WEBPACK FOOTER //
// ./src/locale/modules/salesPlanLocale.js